import * as React from "react";
import { MainLayout } from "../../components/Layout";
import LinkButton from "../../components/LinkButton";
import SmartButton from "../../components/SmartButton";
import { PAYMENT_PLANS } from "../../generated/lib-domain/paymentPlan";
import { PLAN_FEATURES } from "../../generated/lib-domain/paymentPlanFeatures";
import { CardPaymentPlan, PaymentPlanEnum } from "../../generated/UserAPIAgent";
import "./styles.scss";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const cShipLogo = require("../../assets/icon/c-ship_logo.png").default;
// eslint-disable-next-line @typescript-eslint/no-var-requires
const paappLogo = require("../../assets/icon/smakon-emb_logo.svg").default;

interface PaymentPlanDetailPageProps {
    cardPaymentPlan: CardPaymentPlan;
    onNavigateToPaymentMake: () => void;
    close: () => void;
    isLoading: boolean;
}

const PaymentPlanDetailPage = (props: PaymentPlanDetailPageProps) => {
    const paymentPlan = PAYMENT_PLANS.find(
        (plan) => plan.id === props.cardPaymentPlan.paymentPlanId
    );
    const message = (): string => {
        if (props.cardPaymentPlan.campaigns[0]?.description) {
            return props.cardPaymentPlan.campaigns[0].title;
        }
        return paymentPlan.message.description;
    };
    const features = PLAN_FEATURES[paymentPlan.id];
    const isLitePlan =
        props.cardPaymentPlan.paymentPlanId ===
        PaymentPlanEnum.LITE_1M_CARD_1000;
    const whatCanDo = () => {
        return (
            <div className="payment-plan-detail__features">
                <div className="payment-plan-detail__features-title">
                    できること
                </div>
                {features.map((feat, i) => (
                    <div
                        key={i}
                        className="payment-plan-detail__features-content"
                    >
                        <span>・</span>
                        {feat.map((t, i) => (
                            <span key={i}>
                                {t.text && <span>{t.text}</span>}
                                {t.emphasis && (
                                    <span className="payment-plan-detail__features-emphasis">
                                        {t.emphasis}
                                    </span>
                                )}
                                {t.annotation && (
                                    <span className="payment-plan-detail__features-annotation">
                                        ※{t.annotation}
                                    </span>
                                )}
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        );
    };
    return (
        <MainLayout>
            <div>
                <div className="payment-plan-detail__icon">
                    <img
                        width={30}
                        src={isLitePlan ? paappLogo : cShipLogo}
                        className={isLitePlan ? "paapp" : "cship"}
                    />
                    <p className="payment-plan-detail__middle-title">
                        {isLitePlan
                            ? paymentPlan.message.title
                            : "コネクトシップ会員と出会える"}
                    </p>
                    <p className="payment-plan-detail__plan-title">
                        {paymentPlan.title}
                    </p>
                    <div className="payment-plan-detail__amount">
                        <p className="payment-plan-detail__middle-title">
                            入会金0円
                        </p>
                        <p className="payment-plan-detail__amount-title">
                            月額{paymentPlan.amount.toLocaleString("ja-JP")}円
                        </p>
                    </div>
                </div>
            </div>
            <div>{whatCanDo()}</div>
            <div className="payment-plan-detail__footer">
                {
                    <pre className="payment-plan-detail__footer-message">
                        {message()}
                    </pre>
                }
                <SmartButton
                    onClick={() => {
                        props.onNavigateToPaymentMake();
                    }}
                    isLoading={props.isLoading}
                >
                    {
                        PAYMENT_PLANS.find(
                            (plan) =>
                                plan.id === props.cardPaymentPlan.paymentPlanId
                        ).title
                    }
                    を選択する
                </SmartButton>
                <LinkButton
                    to="#"
                    onClick={props.close}
                    lines={2}
                    color="secondary"
                >
                    戻る
                </LinkButton>
                {props.cardPaymentPlan.campaigns[0]?.detail &&
                    props.cardPaymentPlan.campaigns[0]?.detail !== "" && (
                        <pre className="payment-plan-detail__footer-campaign">
                            {props.cardPaymentPlan.campaigns[0].detail}
                        </pre>
                    )}
            </div>
        </MainLayout>
    );
};
export default PaymentPlanDetailPage;
